import * as React from "react";
import { EGlyphicon } from "../../Shared/Glyphicon/EGlyphicon";
import Glyphicon from "../../Shared/Glyphicon/Glyphicon";
import Hyperlink from "../../Shared/Link/Hyperlink";
import { RandomizeSurvivalGuideSlider } from "../Slider/DrawSlider";

export function RandomizeSurvivalGuideSelection() {
    return (
        <Hyperlink whenClicked={() => RandomizeSurvivalGuideSlider()}>
            <div
                style={{
                    pointerEvents: "all",
                    position: "relative",
                    top: "160px",
                    zIndex: 3
                }}
            >
                <Glyphicon icon={EGlyphicon.random} />
            </div>
        </Hyperlink>
    );
}
